<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportDailyProductions"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterWoNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Wo Number " id="filter-" size="sm" :model.sync="filter.filterWoNumber" @input="getFilterWoNumbers" @focus="getFilterWoNumbers" />
						<app-input-combobox-autocomplete :options="filterPartNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Number " id="filter-" size="sm" :model.sync="filter.filterPartNumber" @input="getFilterPartNumbers" @focus="getFilterPartNumbers" />
						<app-input-combobox-autocomplete :options="filterMachines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine " id="filter-" size="sm" :model.sync="filter.filterMachine" @input="getFilterMachines" @focus="getFilterMachines" />
						<app-input-combobox-autocomplete :options="filterProcessTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Process Type " id="filter-" size="sm" :model.sync="filter.filterProcessType" @input="getFilterProcessTypes" @focus="getFilterProcessTypes" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
						<app-input-combobox-autocomplete :options="filterLines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line " id="filter-" size="sm" :model.sync="filter.filterLine" @input="getFilterLines" @focus="getFilterLines" />
						<app-input-combobox-autocomplete :options="filterPartClassifications" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Classification " id="filter-" size="sm" :model.sync="filter.filterPartClassification" @input="getFilterPartClassifications" @focus="getFilterPartClassifications" />
						<!-- <app-input-datepicker  id="fieldset-filter-period-date" label-cols-lg="12"  label="Period Date" size="sm" :model.sync="filter.filterPeriodDateFrom" :isRequired="true" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  reset-button /> -->
						<app-input-datepicker-range  id="fieldset-filter-period-date" label-cols-lg="12" label="Period Date" size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportDailyProductions"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Daily Production</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>

				<b-table-simple :sticky-header="true" small stacked="md" head-variant="light" class="p-0 m-0 table-fixed-columns" bordered hover :responsive="true">
					<b-thead>
						<b-tr>
							<b-th v-for="(itemTable, indexTable) in report.complexColumns[0]" :key="indexTable" :rowspan="itemTable.rowSpan" :colspan="itemTable.colSpan" :class="[getFilterClass(itemTable.title), 
								indexTable === 0 ? 'fixed-column' : '', 
								indexTable === 1 ? 'fixed-column-2' : '', 
								indexTable === 2 ? 'fixed-column-3' : '',
								indexTable === 3 ? 'fixed-column-4' : '']"
							>
								<span v-if="itemTable.title != 'filter'">
									{{ itemTable.title }}
								</span>
								<span v-else>
									<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
										<b-icon-funnel />
									</b-button>
								</span>
							</b-th>
						</b-tr>
						<b-tr>
							<b-th v-for="(itemTable, indexTable) in report.complexColumns[1]" :key="indexTable">{{ itemTable.title }}</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<!-- custom filter row -->
						<b-tr v-if="isShowFilter">
							<b-td class="fixed-column fixed-column-content"></b-td>
							<b-td class="fixed-column-2 fixed-column-content">
								<app-input-datepicker-range @change="getReportDailyProductionsWithoutLoading" id="fieldset-filter-period-date" label-cols-lg="12" label="Period Date" size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
							</b-td>
							<b-td class="fixed-column-3 fixed-column-content">
								<app-input-combobox-autocomplete @change="getReportDailyProductionsWithoutLoading" :options="filterWoNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Wo Number " id="filter-" size="sm" :model.sync="filter.filterWoNumber" @input="getFilterWoNumbers" @focus="getFilterWoNumbers" />
							</b-td>
							<b-td class="fixed-column-4 fixed-column-content">
								<app-input-combobox-autocomplete @change="getReportDailyProductionsWithoutLoading" :options="filterPartNumbers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Number " id="filter-" size="sm" :model.sync="filter.filterPartNumber" @input="getFilterPartNumbers" @focus="getFilterPartNumbers" />
							</b-td>
							<b-td>
								<app-input-combobox-autocomplete @change="getReportDailyProductionsWithoutLoading" :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
							</b-td>
							<b-td></b-td>
							<b-td>
								<app-input-combobox-autocomplete @change="getReportDailyProductionsWithoutLoading" :options="filterLines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line " id="filter-" size="sm" :model.sync="filter.filterLine" @input="getFilterLines" @focus="getFilterLines" />
							</b-td>
							<b-td>
								<app-input-combobox-autocomplete @change="getReportDailyProductionsWithoutLoading" :options="filterLines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line " id="filter-" size="sm" :model.sync="filter.filterLine" @input="getFilterLines" @focus="getFilterLines" />
							</b-td>
							<b-td></b-td>
							<b-td></b-td>
							<b-td>
								<app-input-combobox-autocomplete @change="getReportDailyProductionsWithoutLoading" :options="filterPartClassifications" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Classification " id="filter-" size="sm" :model.sync="filter.filterPartClassification" @input="getFilterPartClassifications" @focus="getFilterPartClassifications" />
							</b-td>
							<b-td></b-td>
							<b-td>
								<app-input-combobox-autocomplete @change="getReportDailyProductionsWithoutLoading" :options="filterMachines" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine " id="filter-" size="sm" :model.sync="filter.filterMachine" @input="getFilterMachines" @focus="getFilterMachines" />
							</b-td>
						</b-tr>


						<b-tr v-for="(itemRow, indexRow) in report.cellValues" :key="indexRow">
							<b-td v-for="(itemCol, indexCol) in itemRow" :key="indexCol" :class="[indexCol === 0 ? 'fixed-column fixed-column-content' : '', 
								indexCol === 1 ? 'fixed-column-2 fixed-column-content' : '', 
								indexCol === 2 ? 'fixed-column-3 fixed-column-content' : '',
								indexCol === 3 ? 'fixed-column-4 fixed-column-content' : '']">
								<div v-if="((indexCol >= 23) || (indexCol >= 14 && indexCol <= 16)) && (indexCol != 17 && indexCol != 18)" class="input-label-currency">{{ Number(itemCol).toLocaleString() }}</div>
								<div v-else>{{ itemCol }}</div>
							</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
			<b-row v-if="true">
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportDailyProductionsPaging != null ? reportDailyProductionsPaging.dataCount : 0)"
											  :per-page="(reportDailyProductionsPaging != null ? reportDailyProductionsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportdailyproduction.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportdailyproduction.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }

	.filterColumn {
		min-width: 0 !important;
	}

	.table-fixed-columns {
		position: relative;
	}

	.table-fixed-columns .fixed-column {
		position: sticky;
		left: 0;
		background-color: #E28B29; /* or the background color of your table header */
		border: 1px solid white;
		z-index: 10; /* Ensure it's on top */
	}

	.fixed-column-content {
		background-color: #F4F7F9 !important;
	}

	.table-fixed-columns .fixed-column-2 {
		position: sticky;
		background-color: #E28B29; /* or the background color of your table header */
		left: 40px; /* Adjust based on the width of the first column */
		border: 1px solid white;
		z-index: 9;
	}

	.table-fixed-columns .fixed-column-3 {
		position: sticky;
		background-color: #E28B29; /* or the background color of your table header */
		left: 145px; /* Adjust based on the total width of the first two columns */
		border: 1px solid white;
		z-index: 8;
	}

	.table-fixed-columns .fixed-column-4 {
		position: sticky;
		background-color: #E28B29; /* or the background color of your table header */
		left: 355px; /* Adjust based on the total width of the first two columns */
		border: 1px solid white;
		z-index: 7;
	}

</style>
<script>
import ReportDailyProduction from '@/models/ReportDailyProduction/ReportDailyProduction';
import ReportDailyProductionList from '@/models/ReportDailyProduction/ReportDailyProductionList';
import ReportDailyProductionFilter from '@/filters/ReportDailyProduction/ReportDailyProductionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportDailyProduction, 
		ReportDailyProductionList, 
		ReportDailyProductionFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportDailyProductions: [],
			reportDailyProductionsPaging: {},
			filterWoNumbers : [],
			filterPartNumbers : [],
			filterMachines : [],
			filterProcessTypes : [],
			filterCustomers : [],
			filterLines : [],
			filterPartClassifications : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			report: [],
		}
	},	methods : {
		getFilterClass(text) {
			if(text == 'filter') return 'filterColumn';
			
			return '';
		},
		getReportDailyProductions : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportDailyProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				console.log('getReportDailyProductions', result);
				if (result != null) {
					this.reportDailyProductions = result.data
					this.report = this.reportDailyProductions[0];
					console.log('getReportDailyProductions', this.report);
					this.reportDailyProductionsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportDailyProductionsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportDailyProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				console.log('getReportDailyProductionsWithoutLoading', result);
				if (result != null) {
					this.reportDailyProductions = result.data
					this.report = this.reportDailyProductions[0];
					console.log('getReportDailyProductionsWithoutLoading', this.report);
					this.reportDailyProductionsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterWoNumbers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDailyProduction.getListCustomUrl(this,'getlistfilterwonumber' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterWoNumbers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterPartNumbers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDailyProduction.getListCustomUrl(this,'getlistfilterpartnumber' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterPartNumbers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterMachines : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDailyProduction.getListCustomUrl(this,'getlistfiltermachine' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterMachines = result.data
				}
			})
			.catch(error => {});
		},
		getFilterProcessTypes : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDailyProduction.getListCustomUrl(this,'getlistfilterprocesstype' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterProcessTypes = result.data
				}
			})
			.catch(error => {});
		},
		getFilterCustomers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDailyProduction.getListCustomUrl(this,'getlistfiltercustomer' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterCustomers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterLines : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDailyProduction.getListCustomUrl(this,'getlistfilterline' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterLines = result.data
				}
			})
			.catch(error => {});
		},
		getFilterPartClassifications : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportDailyProduction.getListCustomUrl(this,'getlistfilterpartclassification' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterPartClassifications = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportDailyProductionFilter();
			this.getReportDailyProductions();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportDailyProductions();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportDailyProduction.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportDailyProduction.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportDailyProduction.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportDailyProduction.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportDailyProductions();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportDailyProduction.deleteMultipleData(this).then(result => {
					this.getReportDailyProductions();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportDailyProductionParent = document.getElementById('table-list-reportdailyproduction').parentNode;
			tableReportDailyProductionParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportDailyProductionParent.scrollWidth - tableReportDailyProductionParent.offsetWidth) == Math.ceil(tableReportDailyProductionParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportDailyProductionParent = document.getElementById('table-list-reportdailyproduction').parentNode;
			tableReportDailyProductionParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportDailyProductionParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportDailyProductionFilter();
		this.getFilterWoNumbers()
		this.getFilterPartNumbers()
		this.getFilterMachines()
		this.getFilterProcessTypes()
		this.getFilterCustomers()
		this.getFilterLines()
		this.getFilterPartClassifications()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Daily Production"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportDailyProductions();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportDailyProductions();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportDailyProductions();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportDailyProductions();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportDailyProductions();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportDailyProduction.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportdailyproductionindex") {
					this.getReportDailyProductionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_daily_production").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
